const getAvatarStorageKey = () => 'mpAvatar';
const getVotedPostsStorageKey = () => 'blogFeedback';

export const STEPS = {
	QUESTION: 'question',
	EVALUATION: 'evaluation',
	FEEDBACK: 'feedback',
	SUBMISSION: 'submission',
	VOTED: 'voted',
};

export const getVotedPosts = () => {
	const votedPosts = localStorage.getItem(getVotedPostsStorageKey());
	return votedPosts ? JSON.parse(votedPosts) : [];
};

export const addVotedPost = (postID) => {
	const votedPosts = getVotedPosts();
	if (!votedPosts.includes(postID)) {
		votedPosts.push(postID);
	}

	localStorage.setItem(getVotedPostsStorageKey(), JSON.stringify(votedPosts));
};

export const getBlogAvatar = () => {
	const storedAvatar = localStorage.getItem(getAvatarStorageKey());
	return storedAvatar ? storedAvatar : 'default';
};

export const setBlogAvatar = (avatarKey) => {
	localStorage.setItem(getAvatarStorageKey(), avatarKey);
};
